import './reports-page.scss';
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/components/store';
import Loader from 'src/components/shared/loader/loader';
import { ReportList } from './report-list';
import { Outlet, useParams } from 'react-router-dom';
import { useNavigate } from 'src/utils/use-navigate';
import DateRangePicker from '../../../shared/date-range-picker/date-range-picker';
import { DateRangeObject } from '@src/utils/datesUtils';
import { DateFilterOptionNew, InsightsSubMenu, ReportName } from '@src/utils/enums';
import ExecutiveSummaryReportItem from './report/ExecutiveSummaryReportItem';

export const ReportsPage: React.FC = observer(() => {
    const { userPreferencesStore, reportsStore, logsStore } = useStores();
    const navigate = useNavigate();
    const { reportType: routeReportType } = useParams();
    // Use route param if present; otherwise default to Executive Summary.
    const reportType = (routeReportType as ReportName | undefined) ?? ReportName.EXECUTIVE_SUMMARY;

    useEffect(() => {
        logsStore.setActiveSubMenu(InsightsSubMenu.REPORTS);
    }, []);
    
    const changeDateFilter = (selectedOption: string, range?: DateRangeObject) => {
        userPreferencesStore.updateAllReportsDate(selectedOption as DateFilterOptionNew, range);
        reportsStore.setDateRange(range ?? selectedOption);
    };

    const handleExecutiveSummaryClick = () => {
        navigate(ReportName.EXECUTIVE_SUMMARY, { replace: true });
    };

    return <div className="reports-logs-page reports" data-testid="reports-page" id={'reports-page'}>
        {userPreferencesStore.isLoading ? <Loader type="full-screen"/> :
            <div className="reports-menu">
                <div className="header-page">
                    <DateRangePicker defaultValue={reportsStore.dateRange} onDateRangeChange={changeDateFilter}/>
                </div>
                <div className="report-list-wrapper">
                    <ExecutiveSummaryReportItem
                        isSelected={reportType === ReportName.EXECUTIVE_SUMMARY}
                        onClick={handleExecutiveSummaryClick}
                    />
                    <ReportList reports={userPreferencesStore.reportsPreferences} hasExecutiveSummary={true}/>
                </div>
            </div>}
        <Outlet/>
    </div>;
});
